import React from 'react'
import './style.css'
import db from '../../database.js'
import loading from '../../img/loading.svg'
import friendsStruggling from '../../img/convo-starts/friends-struggling.png'
import youreStruggling from '../../img/convo-starts/youre-struggling.png'

import Game from './DndGame';
import { Link, Router, Switch, Route } from 'react-router-dom'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {
      content: []
    }
  }

  componentDidMount () {
    var talkRef = db.collection('talkSection')
    talkRef.orderBy('order', 'asc').onSnapshot(function (querySnapshot) {
      var tempCol = []
      querySnapshot.forEach(function (doc) {
        tempCol.push({
          title: doc.data().title,
          body: doc.data().body
        })
        console.log(doc.id, ' => ', doc.data())
      })
      this.setState({
        content: tempCol
      })
    }.bind(this))
  }

  render () {
    var contentItems = []
    for (var bodyItem of this.state.content) {
      if(bodyItem.title.startsWith("[VIDEO]")) {
        let embed = <div className="convo-holder"><iframe width="420" height="315" src="https://www.youtube.com/embed/nCrjevx3-Js" /></div>
        contentItems.push(<Panel title={bodyItem.title.slice(7)} body={embed}/>);
      } else if (bodyItem.title.includes("friends")) {
        let image = <div className="convo-holder"><img className="convo-img" src={friendsStruggling} /></div> ;
        contentItems.push(<Panel title={bodyItem.title} body={image}/>);
        
      } else if (bodyItem.title.includes("you are struggling")) {
        let image = <div className="convo-holder"><img className="convo-img" src={youreStruggling} /></div>  ;
        contentItems.push(<Panel title={bodyItem.title} body={image} />)

      }
    }

    if (!contentItems || contentItems.length === 0) {
      return (<div style={{'textAlign': 'center'}} className='talk-container'>
        <img src={loading} />
      </div>)
    }



    return (
        <div className='page-container' style={{"marginTop": "25px"}}>
          {contentItems}
          <Link className="download-btn" to="/youth/talk">Go back</Link>
        </div>
    )
  }
}


class Panel extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
  }

  render () {
  return (
      <div className="container convo-container">
        <div className="panel panel-default convo-panel">
          <div className="panel-heading heading-convos">{this.props.title}</div>
          <div className="panel-body convo-list">
            <ul style={{ 'list-style': 'none', "padding-left": "10px" }}>
              {this.props.body}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Talk/test.js